module.exports = __webpack_public_path__ + "static/media/phonics_03.c5577cfc.jpg";